var map = {
	"./cs/core": [
		6503,
		503
	],
	"./da/core": [
		5388,
		388
	],
	"./de/core": [
		224,
		224
	],
	"./en/core": [
		8856
	],
	"./es/core": [
		2245,
		245
	],
	"./fr/core": [
		1049,
		49
	],
	"./it/core": [
		7386,
		386
	],
	"./ja/core": [
		2834,
		834
	],
	"./ko/core": [
		6563,
		563
	],
	"./pl/core": [
		9045,
		45
	],
	"./pt-BR/core": [
		7216,
		216
	],
	"./ru/core": [
		574,
		574
	],
	"./sk/core": [
		1087,
		87
	],
	"./sv/core": [
		4218,
		218
	],
	"./uz/core": [
		1988,
		988
	],
	"./zh/core": [
		6899,
		899
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;